import { FC, useEffect } from 'react';

import { useLogger } from '~Hooks';
import * as actions from '../../actions';
import store from '../../store';

/** Renders nothing — its only job is to log the current user out. Developed for TV screens. */
const Logout: FC = () => {
  const logger = useLogger('logout');

  useEffect(() => {
    logger.info('User logged out from the URL');

    // Otherwise App.tsx restores this path on the next login and logs the user straight back out
    store.dispatch({
      type: actions.SET_LAST_VISITED_PATH,
      path: '',
    });

    store.dispatch(actions.setToken(null));
  }, []);

  return null;
};

export default Logout;
